import { FileHelper, TokenData } from '../fileHelper'
import { get } from './common'
type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>

const COS_PREFIX = '/business/material_center/assets'

class Cos extends FileHelper {
  constructor(public prefix: string) {
    super(prefix)
  }

  async getUploadToken(): Promise<TokenData | null> {
    try {
      const res = await get<ApiBaseResult<TokenData>>('/cos/sts_put_token')
      return res.data
    } catch (error) {
      return null
    }
  }

  async getDownloadToken(key: string): Promise<TokenData | null> {
    try {
      const res = await get<ApiBaseResult<TokenData>>('/cos/sts_get_token', {
        key,
      })
      return res.data
    } catch (error) {
      return null
    }
  }
}

export const cos = new Cos(COS_PREFIX)
